import React from 'react';
import et from './et';
import en from './en';
const translations = { et, en };

export const LanguageContext = React.createContext();

const LanguageProvider = ({ locale, children }) => {
	const translate = React.useCallback(
		(translationId, { languageCode = locale, ...props } = {}) => {
			const translation = translations[languageCode][translationId];

			if (!translation) return translationId;

			return typeof translation === 'function'
				? translation(props)
				: translation;
		},
		[locale]
	);

	const value = React.useMemo(
		() => ({
			translate,
			locale
		}),
		[locale, translate]
	);

	return (
		<LanguageContext.Provider value={value}>
			{children}
		</LanguageContext.Provider>
	);
};

export const useActiveLanguageCode = () =>
	React.useContext(LanguageContext).locale;

export const useTranslate = () => React.useContext(LanguageContext).translate;

export const Translate = ({ children, ...props }) => {
	const { translate } = React.useContext(LanguageContext);

	return typeof children === 'function'
		? children(translate)
		: translate(children, props) || children || null;
};

export default LanguageProvider;
